const commonlocalization = {
  nl: {
    bookUrl: 'https://www.micazu.nl/vakantiehuis/duitsland/eifel/kopp/ferienhaus-vulkaneifel-kopp-22798/#availability-prices',
    contactInfoTitle: 'Contactinformatie',
    contactFormTitle: 'Contactformulier',
    germany: 'Duitsland',
    metaDescription: 'Vakantiehuis in Kopp, Duitsland voor grote gezelschappen tot 25 personen.',
    metaKeywords: 'vakantiehuis, huren, kopp, duitsland, grote, gezelschappen, personen, ardennen, dolomieten, wandelen, fietsen, mountainiken, wielrennen, motorrijden, kajakken, kayakken, kano, kanoën, kanoen'
  },
  de: {
    bookUrl: 'https://www.micazu.de/ferienwohnung/deutschland/eifel/kopp/ferienhaus-vulkaneifel-kopp-22798/#availability-prices',
    contactInfoTitle: 'Kontaktinformationen',
    contactFormTitle: 'Kontaktformular',
    germany: 'Deutschland',
    metaDescription: 'Ferienhaus in Kopp, Deutschland für große Gruppen bis zu 25 Personen.',
    metaKeywords: 'ferienhaus, mieten, hütten, deutschland, große, gruppen, menschen, ardennen, dolomiten, wandern, radfahren, mountainbiken, renradfahren, motorradfahren, kajak, kajakfahren, kanu, kanufahren'
  },
  en: {
    bookUrl: 'https://www.micazu.com/vacation-rentals/germany/eifel/kopp/ferienhaus-vulkaneifel-kopp-22798/#availability-prices',
    contactInfoTitle: 'Contact information',
    contactFormTitle: 'Get in touch',
    germany: 'Germany',
    metaDescription: 'Holiday home in Kopp, Germany for large groups up to 25 people.',
    metaKeywords: 'holiday home, rent, kopp, germany, large, groups, people, ardennes, dolomites, hiking, cycling, mountain biking, bicycle racing, motorcycling, kayaking, kayak, canoeing, canoe'
  },
}

export default commonlocalization



// WEBPACK FOOTER //
// ./src/localization/common.js